<div class="progress ml-0 mr-0" style="height:20px;" [ngClass]="{'w-98 h-33': fat}">
    <!--GREEN PROGRESSBAR-->
    <div *ngIf="project?.progress == 0 && project?.overduedays == 0 " class="align-right pl-0 pr-0 bg-ex"
        role="progressbar" [style.width]="project?.progress +'%'" [attr.aria-valuenow]="0" aria-valuemin="0"
        aria-valuemax="100">
        <h6 [ngClass]="{'lh-33 f-13': fat, 'lh-20': !fat}"
            class="progress-text-zero text-muted align-middle mb-0 mr-1 ml-1">0%</h6>
    </div>
    <div *ngIf="project?.progress > 0 && project?.overduedays == 0 " class="progress-bar progress-green bg-ex"
        role="progressbar" [style.width]="project?.progress +'%'"
        [attr.aria-valuenow]="project?.progress | number: '1.0-0' " aria-valuemin="0" aria-valuemax="100">
        <h6 class="progress-text align-middle mb-0 lh-20">{{project?.progress | number:'1.0-0'}}%</h6>
    </div>
    <!--YELLOW PROGRESSBAR-->
    <div *ngIf="project?.progress == 0 && project?.overduedays > 0 && project?.overduedays < 3"
        class="align-right pl-0 pr-0 bg-ex" role="progressbar" [style.width]="project?.progress +'%'"
        [attr.aria-valuenow]="0" aria-valuemin="0" aria-valuemax="100">
        <h6 [ngClass]="{'lh-33 f-13': fat, 'lh-20': !fat}"
            class="progress-text-zero text-muted align-middle  mb-0 mr-1 ml-1">0%
            <span [ngClass]="{'indicator-icon-yellow-progress-portal': fat}"
                class="material-icons indicator-icon-yellow-progress cursor-default pr-1 d-none d-sm-block"
                matTooltip="{{ project.title }} {{ 'projectlist.yellowindicatortool' | trans }}"
                matTooltipPosition="above" matTooltipShowDelay="500">error</span>
        </h6>
    </div>
    <div *ngIf="project?.progress > 0 && project?.overduedays > 0 && project?.overduedays < 3"
        class="progress-bar progress-yellow bg-ex" role="progressbar" [style.width]="project?.progress +'%'"
        [attr.aria-valuenow]="project?.progress | number: '1.0-0' " aria-valuemin="0" aria-valuemax="100">
        <h6 class="progress-text align-middle mb-0 lh-20">{{project?.progress | number:'1.0-0'}}%</h6>
    </div>
    <!--RED PROGRESSBAR-->
    <div *ngIf="project?.progress == 0 && project?.overduedays >= 3" class="align-right pl-0 pr-0 bg-ex"
        role="progressbar" [style.width]="project?.progress +'%'" [attr.aria-valuenow]="0" aria-valuemin="0"
        aria-valuemax="100">
        <h6 [ngClass]="{'lh-33 f-13': fat, 'lh-20': !fat}"
            class="progress-text-zero text-muted align-middle mb-0 mr-1 ml-1">0%
            <span [ngClass]="{'indicator-icon-red-progress-portal': fat}"
                class="material-icons indicator-icon-red-progress cursor-default pr-1 d-none d-sm-block"
                matTooltip="{{ project.title }} {{ 'projectlist.redindicatortool' | trans }}" matTooltipPosition="above"
                matTooltipShowDelay="500">whatshot</span>
        </h6>
    </div>
    <div *ngIf="project?.progress > 0 && project?.overduedays >= 3" class="progress-bar progress-red bg-ex"
        role="progressbar" [style.width]="project?.progress +'%'"
        [attr.aria-valuenow]="project?.progress | number: '1.0-0' " aria-valuemin="0" aria-valuemax="100">
        <h6 class="progress-text align-middle mb-0 lh-20">{{project?.progress | number:'1.0-0'}}%</h6>
    </div>
</div>